export class ObjectUtils {
    static isMergeableObject = (item): boolean => {
        return ObjectUtils.isObject(item) && !Array.isArray(item);
    };

    static isObject = (item: any): boolean => {
        return item !== null && typeof item === 'object';
    };

    static mergeObjects = <T extends object = object>(target: T, ...sources: T[]): T => {
        if (!sources.length) {
            return target;
        }
        const source = sources.shift();
        if (source === undefined) {
            return target;
        }

        if (ObjectUtils.isMergeableObject(target) && ObjectUtils.isMergeableObject(source)) {
            Object.keys(source).forEach((key: string) => {
                if (ObjectUtils.isMergeableObject(source[key])) {
                    if (!target[key]) {
                        target[key] = {};
                    }
                    ObjectUtils.mergeObjects(target[key], source[key]);
                } else {
                    target[key] = source[key];
                }
            });
        }

        return ObjectUtils.mergeObjects(target, ...sources);
    };

    static unflatten = (data: any): object => {
        const result = {};
        for (const i in data) {
            if (i !== null) {
                const keys = i.split('.');
                if (keys !== null && keys.length > 0) {
                    keys.reduce((r, e, j) => {
                        return r[e] || (r[e] = isNaN(Number(keys[j + 1])) ? (keys.length - 1 === j ? data[i] : {}) : []);
                    }, result);
                }
            }
        }

        return result;
    };
}
